export default __webpack_public_path__ + "static/media/snow.67794db5.svg";